/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare both the plotted values and chart formatting after an XLSX round trip. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XLSX 保存并重新打开后，需要同时核对绘图数据和格式。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "Compare both the plotted values and chart formatting after an XLSX round trip. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_4_figure_caption as "gc.search_guides.gridcraft_excel_compatibility.sections.4.figure.caption" }